import React from 'react';
import { Hero } from './Hero';
import { ProblemSection } from './ProblemSection';
import { MethodSection } from './MethodSection';
import { IncludesSection } from './IncludesSection';
import { ForWhoSection } from './ForWhoSection';
import { OfferSection } from './OfferSection';
import { Button } from './ui/Button';
import { motion, useScroll, useTransform } from 'framer-motion';
export function LandingPage() {
  const {
    scrollYProgress
  } = useScroll();
  const opacity = useTransform(scrollYProgress, [0.1, 0.2], [0, 1]);
  const y = useTransform(scrollYProgress, [0.1, 0.2], [20, 0]);
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#FDFBF7]" data-id="element-65">
      <Hero data-id="element-66" />
      <ProblemSection data-id="element-67" />
      <MethodSection data-id="element-68" />
      <IncludesSection data-id="element-69" />
      <ForWhoSection data-id="element-70" />
      <OfferSection data-id="element-71" />

      {/* Sticky Mobile CTA */}
      <motion.div style={{
      opacity,
      y
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden z-50" data-id="element-72">
        <Button fullWidth onClick={scrollToOffer} className="shadow-lg" data-id="element-73">
          Quiero empezar hoy
        </Button>
      </motion.div>

      {/* Footer */}
      <footer className="bg-[#2D2D2D] text-white py-12 px-4 text-center" data-id="element-74">
        <p className="text-sm text-gray-400 mb-4" data-id="element-75">
          © 2024 Rodillas Fuertes 65+. Todos los derechos reservados.
        </p>
        <p className="text-xs text-gray-500 max-w-md mx-auto" data-id="element-76">
          Este producto no sustituye el consejo médico profesional. Siempre
          consulta a tu médico antes de comenzar cualquier programa de
          ejercicios.
        </p>
      </footer>
    </div>;
}